/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_TitleInputs */

const en_admin_permissions_title = /** @type {(inputs: Admin_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

const zh_admin_permissions_title = /** @type {(inputs: Admin_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限管理`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Admin_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_title = /** @type {((inputs?: Admin_Permissions_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_title(inputs)
	return zh_admin_permissions_title(inputs)
});
export { admin_permissions_title as "admin.permissions.title" }